'use strict';

let requireOrNull = require;
if (!process.env.WEBPACK) {
  requireOrNull = str => str;
}

const {
  critModules: LocalCritModules,
  nonCritModules,
  pageReadyModules,
} = require('../local/js_modules');

const critModules = [
  ...LocalCritModules,
  {
    name: 'Variations',
    module: requireOrNull(
      '../../../../modules/variations/frontend/variations-widget'
    ),
    featureCheck: serverObj => serverObj.variations,
  },
];

module.exports = { critModules, nonCritModules, pageReadyModules };
